import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file 列表页
 * @author alfielv
 */
import _ from 'lodash';
import React, { useImperativeHandle, forwardRef, useMemo } from 'react';
import classNames from 'classnames';
import { PREFIX_CLS } from '../../constants';
import ToolbarArea from './ToolbarArea';
import FilterArea from './FilterArea';
import MainArea from './MainArea';
import BatchArea from './BatchArea';
import CustomMainArea from './CustomMainArea';
import useList from './hooks/useList';
import useFilters from './hooks/useFilters';
import './index.css';
var prefixCls = "".concat(PREFIX_CLS, "-listview");
var globalFuncs = {};

var registerListFuncs = function registerListFuncs(funcs) {
  Object.keys(funcs).forEach(function (funcName) {
    if (funcs[funcName]) {
      globalFuncs[funcName] = funcs[funcName];
    }
  });
};

;
var ListView = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      options = props.options,
      payloads = props.payloads,
      customFunctions = props.customFunctions; // 合并全局

  var combineFuncs = _objectSpread(_objectSpread({}, globalFuncs), customFunctions);

  var _options = options({
    payloads: payloads,
    customFunctions: combineFuncs
  }),
      fetchConfig = _options.fetchConfig,
      toolbarConfig = _options.toolbarConfig,
      filterConfig = _options.filterConfig,
      batchConfig = _options.batchConfig,
      tableConfig = _options.tableConfig;

  var _tableConfig$customMa = tableConfig.customMainArea,
      customMainArea = _tableConfig$customMa === void 0 ? '' : _tableConfig$customMa;

  var _useFilters = useFilters({
    filterConfig: filterConfig
  }),
      customFilterComponent = _useFilters.customFilterComponent,
      customFiltersLoaded = _useFilters.customFiltersLoaded,
      filterMap = _useFilters.filterMap; // 基于激活态自定义筛选项 || 全量filters 的filter key集合


  var activeFilterKeys = _.get(filterConfig, 'customConfigure.activeFilterKeys', _.keys(filterMap)); // 额外传入的filterData key集合


  var bizFilterKeys = _.keys(_.get(filterConfig, 'defaultValuesByKey', {}));

  var filterControls = _.get(filterConfig, 'controls'); // 默认展开筛选项个数


  var expandFilterCount = _.get(filterConfig, 'expandFilterCount'); // 基于自定义筛选项active的默认静态filterData（来自每项formItem defaultValue）


  var defaultFilterData = useMemo(function () {
    return _.reduce(activeFilterKeys, function (prev, key) {
      // 默认名称（尤其是多name场景）
      var defaultName = _.get(filterMap[key], 'name'); // 默认值


      var defaultValue = _.get(filterMap[key], 'defaultValue');

      if (!_.isNil(defaultValue)) {
        return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, defaultName, defaultValue));
      }

      return prev;
    }, {});
  }, [activeFilterKeys, filterMap]); // 基于自定义筛选项active的默认静态filterData（来自每项formItem defaultValue）

  var defaultBizFilterData = useMemo(function () {
    return _.reduce(bizFilterKeys, function (prev, key) {
      // 默认名称（尤其是多name场景）
      var defaultName = _.get(filterMap[key], 'name'); // 默认值


      var defaultValue = _.get(filterConfig, 'defaultValuesByKey', {})[key];

      if (!_.isNil(defaultValue)) {
        return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, defaultName, defaultValue));
      }

      return prev;
    }, {});
  }, [bizFilterKeys, filterMap, filterConfig]);
  var listProps = useList(_objectSpread({
    // 全量defaultFilterData, 业务场景定义的filterData优先级高于静态的defaultFilterData
    defaultFilterData: _objectSpread(_objectSpread({}, defaultFilterData), defaultBizFilterData),
    customFiltersLoaded: customFiltersLoaded,
    tableConfig: tableConfig,
    filterConfig: filterConfig
  }, fetchConfig));
  var pageNo = listProps.pageNo,
      setPageNo = listProps.setPageNo,
      pageSize = listProps.pageSize,
      setPageSize = listProps.setPageSize,
      selectKeys = listProps.selectKeys,
      setSelectKeys = listProps.setSelectKeys,
      batchShow = listProps.batchShow,
      setBatchShow = listProps.setBatchShow,
      filterData = listProps.filterData,
      setFilterData = listProps.setFilterData,
      orderBy = listProps.orderBy,
      orderType = listProps.orderType,
      setOrderBy = listProps.setOrderBy,
      setOrderType = listProps.setOrderType,
      tableData = listProps.tableData,
      loading = listProps.loading;
  useImperativeHandle(ref, function () {
    return _objectSpread({}, listProps);
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(className, prefixCls, {
      'batch-show': batchShow
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "__top-container")
  }, toolbarConfig && /*#__PURE__*/React.createElement(ToolbarArea, {
    prefixCls: prefixCls,
    toolbarConfig: toolbarConfig
  }), batchConfig && batchShow && /*#__PURE__*/React.createElement(BatchArea, {
    prefixCls: prefixCls,
    selectKeys: selectKeys,
    setSelectKeys: setSelectKeys,
    batchConfig: batchConfig,
    setBatchShow: setBatchShow
  })), filterConfig && customFiltersLoaded && /*#__PURE__*/React.createElement(FilterArea, {
    prefixCls: prefixCls,
    controls: filterControls,
    filterData: filterData,
    customFilterComponent: customFilterComponent,
    activeFilterKeys: activeFilterKeys,
    bizFilterKeys: bizFilterKeys,
    defaultFilterData: defaultFilterData,
    resetable: _.get(filterConfig, 'resetable', false),
    filterMap: filterMap,
    setFilterData: setFilterData,
    setPageNo: setPageNo,
    expandFilterCount: expandFilterCount
  }), !customMainArea && _.get(tableConfig, 'columns.length', 0) > 0 && /*#__PURE__*/React.createElement(MainArea, {
    prefixCls: prefixCls,
    tableConfig: tableConfig,
    pageNo: pageNo,
    pageSize: pageSize,
    tableData: tableData,
    loading: loading,
    selectKeys: selectKeys,
    setPageNo: setPageNo,
    setPageSize: setPageSize,
    setSelectKeys: setSelectKeys,
    orderBy: orderBy,
    orderType: orderType,
    setOrderBy: setOrderBy,
    setOrderType: setOrderType,
    setBatchShow: setBatchShow
  }), customMainArea && /*#__PURE__*/React.createElement(CustomMainArea, {
    prefixCls: prefixCls,
    tableConfig: tableConfig,
    filterData: filterData,
    tableData: tableData,
    loading: loading
  }));
});
ListView.registerListFuncs = registerListFuncs;
export default ListView;